import React from 'react';
import { NoDataIcon } from '@components-library/Icons/iconsComponents';
import { Text } from '@components-library/Typography';
import { keyMap } from '@locales/lokalise/keyMap';
import styles from './gridNoDataPlaceholder.module.scss';

interface IGridNoDataPlaceholder {
  show: boolean;
  placeholderText?: string;
  columnsLength: number;
  viewMode: 'primary' | 'secondary';
}

export const GridNoDataPlaceholder = ({
  show,
  columnsLength,
  viewMode = 'primary',
  placeholderText,
}: IGridNoDataPlaceholder) => {
  return !show ? null : (
    <tr className={styles.row}>
      <td colSpan={columnsLength} className={styles.noDataCell}>
        <div className={styles.noDataContainer}>
          <NoDataIcon type={viewMode} className={styles.noDataIcon} />
          <Text className={styles.text}>{placeholderText ?? keyMap.commonNoResults}</Text>
        </div>
      </td>
    </tr>
  );
};
